/** The top bar: the account pill, the one-time full-screen offer, and the gear menu. */

import { type Component, Show } from 'solid-js';
import { acceptFullscreenOffer, declineFullscreenOffer } from '../../app/fullscreen.ts';
import { account } from '../../state/library.ts';
import { fullscreenOffer, setModal } from '../../state/ui.ts';
import { Fullscreen } from '../icons/nav.tsx';
import glass from '../primitives/Glass.module.css';
import { GlassPill } from '../primitives/Glass.tsx';
import styles from './Hud.module.css';
import { Menu } from './Menu.tsx';

/** What the pill says depends on how far the user has got with setup. */
function accountLabel(): string {
  const a = account();
  if (a.signedIn) return a.name ?? 'Signed in';
  return a.configured ? 'Sign in' : 'Demo mode';
}

/**
 * The offer a tablet gets on its first open. It lives in the top bar's own
 * row, where there is nothing behind it: the deck is framed below the bar,
 * so the card can never sit over a control.
 */
const FullscreenOffer: Component = () => (
  <fieldset
    class={[glass.glass, styles.offer]}
    aria-label="Full screen"
    data-testid="fullscreen-offer"
  >
    <span class={styles.offerText}>Use the whole screen?</span>
    <button type="button" class={styles.offerYes} onClick={acceptFullscreenOffer}>
      <Fullscreen />
      <span>Full screen</span>
    </button>
    <button type="button" class={styles.offerNo} onClick={declineFullscreenOffer}>
      Not now
    </button>
  </fieldset>
);

export const TopBar: Component = () => (
  <header class={styles.topbar} data-topbar>
    <GlassPill label="Account" onClick={() => setModal('settings')}>
      <span class={[styles.dot, { [styles.live as string]: account().signedIn }]} />
      <span class={styles.label} data-testid="account-label">
        {accountLabel()}
      </span>
    </GlassPill>

    <div class={styles.topbarMiddle}>
      <Show when={fullscreenOffer()}>
        <FullscreenOffer />
      </Show>
    </div>

    <Menu />
  </header>
);
